import { ProductsQueryVariables, TaxonomyEnum } from '.codegen/generatedApi'
import { Dictionary, EntityAdapter, EntityState } from '@reduxjs/toolkit'
import { ParsedImgMedia, parseImgMedia } from 'helpers'
import { TermBase } from 'types'
import { TermIdentifier } from './taxonomyTypes'

export type ProductSearchArgs = ProductsQueryVariables & {
  type?: 'products' | 'brands'
  brands?: any;
}
// {
//   search?: string,
//   size: number,
//   offset: number,
//   taxArray?: TaxQueryNode[]
// }

export type ImgMedia = ReturnType<typeof parseImgMedia>

export type EntityStatus = 'partial' | 'full'

export type Product<T extends EntityStatus = EntityStatus> = {
  status?: T
  id: ProductId
  title: string
  slug: string
  brand: string
  featuredImage?: ParsedImgMedia
  defaultImage?: any
  images: ParsedImgMedia[]
  packShots: ParsedImgMedia[]
  organic?: boolean
  content?: string
  packQty?: number
  packUnit?: string
  sticker?: string
  stickerImage?: any
  packSize?: string
  mainCategory?: TermBase
  productCategories: TermBase[]
  stockists: TermBase[]
  brands: TermBase[]
  subbrands: TermBase[]
  organics: TermBase[]
  producingCountries: TermBase[]
  countries: TermBase[]
}

export type ProductId = number

export type ProductCollection = Dictionary<Product>
export type ProductList = ProductId[]

export type ResultsSliceState = {
  perPage: number
  page: number
  prevPage?: number
  count: number
  status: 'idle' | 'loading' | 'failed'
}

export type PostTypeState = ResultsSliceState & EntityState<Product>

export type ProductEntityAdapter = EntityAdapter<Product>

// export type TaxQueryNode = RootQueryToProductConnectionWhereArgsTaxArray
export type TaxQueryNode = {
  taxonomy: TaxonomyEnum
  terms: string[]
  includeChildren?: boolean
}

export type ProductQueryWhereArgs = {
  search?: String
  taxArray?: TaxQueryNode[]
}

export type ParsedProductsQuery = {
  products: Product[]
  count: number
}

export enum QueriedObjectType {
  TERM = 'TERM',
  PRODUCT = 'PRODUCT',
}

export type QueriedObjectId = QueriedObject['id']

export type QueriedObject =
  | {
      type: QueriedObjectType.PRODUCT
      id: string
    }
  | {
      type: QueriedObjectType.TERM
      id: TermIdentifier
    }
